import { motion } from 'motion/react'
import { CheckCircle2, Mail, Sparkles } from 'lucide-react'

/**
 * ThankYouMessage
 * Success confirmation shown after sweepstakes entry submission
 */
const ThankYouMessage = () => {
  return (
    <div className="p-8 text-center">
      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ type: 'spring', duration: 0.5 }}
        className="mb-6"
      >
        <div className="w-20 h-20 bg-gradient-to-r from-purple-600 to-pink-600 rounded-full flex items-center justify-center mx-auto shadow-lg">
          <CheckCircle2 className="w-12 h-12 text-white" />
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
      >
        <h2 className="text-2xl font-bold text-gray-900 mb-3">
          You're Entered!
        </h2>
        <p className="text-gray-600 mb-6 leading-relaxed">
          Thank you for entering our sweepstakes! We've sent a confirmation email with all the details.
        </p>

        {/* Email Confirmation Notice */}
        <div className="bg-purple-50 rounded-lg p-4 mb-6 border border-purple-200">
          <div className="flex items-center justify-center text-purple-700 mb-2">
            <Mail className="w-5 h-5 mr-2" />
            <span className="font-semibold">Check Your Email</span>
          </div>
          <p className="text-sm text-purple-900">
            We sent you a confirmation with your entry details and next steps.
          </p>
        </div>

        {/* What's Next */}
        <div className="bg-gradient-to-r from-purple-50 to-pink-50 rounded-lg p-4 border border-purple-100">
          <div className="flex items-center justify-center text-purple-700 mb-2">
            <Sparkles className="w-5 h-5 mr-2" />
            <span className="font-semibold">What's Next?</span>
          </div>
          <p className="text-sm text-gray-700">
            We'll notify the winner via email. In the meantime, explore our photographers and book your perfect match!
          </p>
        </div>

        {/* Auto-close notice */}
        <p className="text-xs text-gray-500 mt-6">
          This window will close automatically...
        </p>
      </motion.div>
    </div>
  )
}

export default ThankYouMessage
